/** The subset of a tournament that decides who may manage it. */
export interface ManageableTournament {
  organizers: { id: string }[]
  source?: string | null
}

/**
 * Who may manage an event — mirrors `is_tournament_organizer` in Postgres.
 *
 * Linked organizers always can. GamerPlug team members additionally manage
 * every event *created on GamerPlug* (`source` null); imported events
 * (battlefy / challengermode) are synced from their platform and stay
 * organizer-only. This is a UI convenience — the database enforces the same
 * rule in RLS and every organizer RPC.
 */
export function canManageTournament(
  t: ManageableTournament,
  userId: string | null | undefined,
  isTeamMember: boolean
): boolean {
  if (!userId) return false
  if (t.organizers.some((o) => o.id === userId)) return true
  return isTeamMember && !t.source
}
